export const proctorConfig = {
  BaseUrl: "/proctoring",
  TokenKey: "proctor-token",
}
